import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ac-main-form !border-none" }
const _hoisted_2 = { class: "ac-form-control" }
const _hoisted_3 = { for: "title" }
const _hoisted_4 = {
  key: 0,
  class: "ac-form-control"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "color" }, " Renk ", -1)
const _hoisted_6 = { class: "ac-form-control" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }

import type { metaField, ColorMetaField } from "../../../types/metas"
import { reactive } from "vue"



export default /*#__PURE__*/_defineComponent({
  __name: 'metaManagerForm',
  props: ["existingMeta", "metaTitle" , "hasColor"],
  emits: ['metaAdded', 'metaUpdated'],
  setup(__props, { emit: __emit }) {


const emits = __emit
const props = __props


const meta = reactive<metaField | ColorMetaField>({
    id: props.existingMeta?.id ?? "",
    name: props.existingMeta?.name ?? "",
    color: props.existingMeta?.color ?? "",
})

const emitAddMeta = () => {
    if (!meta.name) { 
        alert("Lütfen müşteri durumu adını giriniz.")
    } else {
       if(props.hasColor){
        emits('metaAdded', {name: meta.name, color: meta.color})
       } else {
        emits('metaAdded', {name: meta.name})
       }
    }
}

const emitUpdateMeta = () => {
    if (!meta.name) { 
        alert("Lütfen müşteri durumu adını giriniz.")
    } else {
        emits('metaUpdated', meta)
    }
}

const handleFormSubmit = () => {
    if (props.existingMeta) {
        emitUpdateMeta()
    } else {
        emitAddMeta()
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, _toDisplayString(props.metaTitle) + " Adı ", 1),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        id: "title",
        class: "",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((meta.name) = $event))
      }, null, 512), [
        [_vModelText, meta.name]
      ])
    ]),
    (props.hasColor)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createElementVNode("input", {
            type: "color",
            id: "color",
            class: "w-full",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((meta.color) = $event))
          }, null, 512), [
            [_vModelText, meta.color]
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        type: "button",
        class: "ac-primary-button w-2/6",
        onClick: handleFormSubmit
      }, [
        (!__props.existingMeta)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(props.metaTitle) + " Oluştur ", 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(props.metaTitle) + " Güncelle ", 1))
      ])
    ])
  ]))
}
}

})